import { db } from '../firebase';
import { doc, getDoc, setDoc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { isDemoMode } from '../demo/isDemoMode';
import demoStore from '../demo/demoStore';

export const getFloorPlan = async (eventId) => {
  if (isDemoMode) {
    return demoStore.getDoc('floorPlans', eventId) || null;
  }
  const ref = doc(db, 'floorPlans', eventId);
  const snap = await getDoc(ref);
  return snap.exists() ? snap.data() : null;
};

export const saveFloorPlan = async (eventId, data) => {
  if (isDemoMode) {
    demoStore.setDoc('floorPlans', eventId, { ...data, updatedAt: new Date() });
    return;
  }
  const ref = doc(db, 'floorPlans', eventId);
  await setDoc(ref, { ...data, updatedAt: serverTimestamp() }, { merge: true });
};

export const updateRegistrationBoothNumber = async (registrationId, boothNumber) => {
  if (isDemoMode) {
    demoStore.updateDoc('mpsEventRegistration', registrationId, { boothNumber });
    return;
  }
  const ref = doc(db, 'mpsEventRegistration', registrationId);
  await updateDoc(ref, { boothNumber });
};
